import React, { useState } from "react";
import { Card, Typography, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSpring, animated } from "@react-spring/web";

const MobileCard = ({ member, isSelected }) => {
  const [isHovered, setHovered] = useState(false);
  const navigate = useNavigate();

  const boxAnimationStyle = useSpring({
    transform: isHovered ? "translateY(-20px)" : "translateY(0px)",
    config: { tension: 600, friction: 100 },
  });

  const handleCardClick = () => {
    if (member.uuid) {
      navigate(`/profile/${member.uuid}`);
    }
  };

  return (
    <Card
      onClick={handleCardClick}
      elevation={20}
      sx={{
        background: isHovered ? "rgba(4, 4, 4, 0.4)" : "rgba(38, 38, 38, 0.3)",
        backdropFilter: "blur(20px)",
        borderRadius: "12px",
        boxShadow: "0 4px 10px rgba(5, 5, 5, 0.4)",
        textAlign: "center",
        position: "relative",
        overflow: "hidden",
        transition: "background 0.3s ease, filter 0.3s ease",
        filter: isSelected ? "none" : "blur(4px) brightness(0.6)",
        opacity: isSelected ? 1 : 0.6,
        cursor: "pointer",
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <img
        src={member.image_url || "AvatarImg"}
        alt={member.name}
        style={{ width: "100%" }}
      />
      <animated.div style={boxAnimationStyle}>
        <Box
          sx={{
            position: "absolute",
            bottom: 0,
            width: "87%",
            backdropFilter: "blur(10px)",
            background: "rgba(0, 0, 0, 0.3)",
            color: "white",
            textAlign: "start",
            padding: "5px 15px",
            marginX: "10px",
            marginY: "4px",
            borderRadius: "5px",
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontFamily: "Poppins, sans-serif",
              fontWeight: "600",
              fontSize: ".7rem",
              marginBottom: "5px",
            }}
          >
            {member.name}
          </Typography>

          <Typography
            variant="body2"
            sx={{
              fontFamily: "Poppins, sans-serif",
              fontSize: ".6rem",
              color: "rgb(255, 255, 255)",
            }}
          >
            {member.role}
          </Typography>
        </Box>
      </animated.div>
    </Card>
  );
};

export default MobileCard;
